/* eslint-disable */
import { MODULE_NAME, } from './../constants';

export const GET_STORES = `${MODULE_NAME}/GET_STORES`;
export const GET_STORES_SUCCESS = `${MODULE_NAME}/GET_STORES_SUCCESS`;
export const GET_STORES_ERROR = `${MODULE_NAME}/GET_STORES_ERROR`;

export const SET_CURRENT_STORE = `${MODULE_NAME}/SET_CURRENT_STORE`;
export const SET_CURRENT_STORE_LANGUAGE = `${MODULE_NAME}/SET_CURRENT_STORE_LANGUAGE`;
